import { useEffect, useRef } from "react";
export const useDebugWhatChanged = (things) => {
    useEffect(() => console.error("useDebugWhatChanged hook active"), []);
    const previousThings = useRef({ ...things });
    useEffect(() => {
        Object.entries(things).forEach(([key, newValue]) => {
            const lastValue = previousThings.current[key];
            if (lastValue !== newValue)
                console.log(`${key} changed from:`, lastValue, "to", newValue);
        });
        previousThings.current = { ...things };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...Object.values(things)]);
};
